class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Yen Aura: free-gift threshold + gift wrapping product (functions defined below).
    thresholdproduct();
    shipping_pro();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


// CD Kashish
window.addEventListener('load', function() {
    thresholdproduct();

    const shipping_id = parseInt(document.querySelector('body').getAttribute('data-shipping-pro'));
    const load_cart_json = new XMLHttpRequest();
    const load_check_cart_json = new XMLHttpRequest();
    load_check_cart_json.open("GET", "/cart.js", true);
    load_check_cart_json.getResponseHeader("Content-type", "application/json");
    load_check_cart_json.send();
    load_check_cart_json.onload = function() {
      const load_cart_data = JSON.parse(this.responseText);
      var load_has_shi_pro = false;
      load_cart_data.items.forEach(function(item){
        if(item.variant_id == shipping_id && load_has_shi_pro == false){
          load_has_shi_pro = true;
        }
      });
      if(load_has_shi_pro == true){
        document.querySelector('#gift_wrapping_input').checked = true;
        document.querySelector('.gift_wrapping .gift_wrapping_message').classList.add('gift_message_show');
      }
      shipping_pro();
    }
})

document.addEventListener('cart:update', (event) => {
  thresholdproduct()
  const shipping_id = parseInt(document.querySelector('body').getAttribute('data-shipping-pro'));
    const load_cart_json = new XMLHttpRequest();
    const load_check_cart_json = new XMLHttpRequest();
    load_check_cart_json.open("GET", "/cart.js", true);
    load_check_cart_json.getResponseHeader("Content-type", "application/json");
    load_check_cart_json.send();
    load_check_cart_json.onload = function() {
      const load_cart_data = JSON.parse(this.responseText);
      var load_has_shi_pro = false;
      load_cart_data.items.forEach(function(item){
        if(item.variant_id == shipping_id && load_has_shi_pro == false){
          load_has_shi_pro = true;
        }
      });
      if(load_has_shi_pro == true){
        document.querySelector('#gift_wrapping_input').checked = true;
        document.querySelector('.gift_wrapping .gift_wrapping_message').classList.add('gift_message_show');
      }
      shipping_pro();
    }
})

 function thresholdproduct(){
    if(document.querySelector('body').getAttribute('data-th-price') != undefined && document.querySelector('body').getAttribute('data-th-id')) {
      var price = document.querySelector('body').getAttribute('data-th-price') * 100,
          pro_id = parseInt(document.querySelector('body').getAttribute('data-th-id')),
          price2 = document.querySelector('body').getAttribute('data-th-price2') * 100,
          pro_id2 = parseInt(document.querySelector('body').getAttribute('data-th-id2')),
          has_pro = false,
          first_pro = false,
          second_pro = false;
  
      const cart_json = new XMLHttpRequest();
      const check_cart_json = new XMLHttpRequest();
      
      // check_cart_json.open("GET", "/cart.js", true);
      // check_cart_json.getResponseHeader("Content-type", "application/json");
      // check_cart_json.send();
      // check_cart_json.onload = function() {
      //   const cart_data = JSON.parse(this.responseText);
      //   cart_data.items.forEach(function(item){
      //     if(item.variant_id == pro_id && has_pro == false){
      //       has_pro = true;
      //     }
      //   });

      // }
      
      cart_json.open("GET", "/cart.js", true);
      cart_json.getResponseHeader("Content-type", "application/json");
      cart_json.send();
      cart_json.onload = function() {
        const cart_data = JSON.parse(this.responseText);
        cart_data.items.forEach(function(item){
          if(parseInt(item.id) == parseInt(pro_id)){
            has_pro = true;
            first_pro = true;
          }
          
          if(item.id == pro_id2){
            has_pro = true;
            second_pro = true;
          }
        });
        
        var add_pro = true;
        if (cart_data.total_price < price2 && second_pro == true){
          add_pro = false;
        }else if (cart_data.total_price < price && first_pro == true){
          add_pro = false;
        }
        
        
        if (add_pro == true){
          if(first_pro == false || second_pro == false){
            // var upsell_arr = new FormData();
            // upsell_arr.append('id', pro_id);
            // upsell_arr.append('quantity', 1);
            // upsell_arr.append('sections', document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id));
            // fetch(window.Shopify.routes.root + 'cart/add.js', {
            //   method: 'POST',
            //   body: upsell_arr
            // })
            // .then((upsellresponse) => upsellresponse.json())
            // .then(upsellresponse => {
            //   document.querySelector('cart-drawer').renderContents(upsellresponse)
            // })
            // .catch((error) => {
            //   console.error(error);
            // });

            var upsell_arr = new FormData();
            var upsell_item = [];
            
            if(first_pro == false && cart_data.total_price > price && price != 0){
              upsell_item.push({
                  id: pro_id, 
                  quantity: 1
              });
              first_pro = true;
            }
            
            if(second_pro == false && cart_data.total_price > price2 && price2 != 0){
              upsell_item.push({
                  id: pro_id2, 
                  quantity: 1
              });
              second_pro = true;
            }
            
            if(upsell_item.length){
              var formData = {
               'items': upsell_item,
               'sections': ['cart-drawer']
              }
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then(response => {
                return response.json();
              })
              .then((json) => {
                const parser = new DOMParser();
                const doc1 = parser.parseFromString(json.sections['cart-drawer'], "text/html");
                document.querySelector('cart-drawer').innerHTML = doc1.querySelector('cart-drawer').innerHTML;
                // if(getCookie("gift_pro") != ''){
                //   document.querySelector('#gift_wrapping_input').checked = true
                // }
                // gift_events()
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
          }
        }
        else{
          if(first_pro == true || second_pro == true){
            let items = {};
            var items_remove = false;
            if(first_pro == true && cart_data.total_price < price){
              items[pro_id]=0;
              first_pro = false;
              items_remove = true;
            }
            if(second_pro == true && cart_data.total_price < price2){
              items[pro_id2]=0;
              second_pro = false;
              items_remove = true;
            }
  
            const body = JSON.stringify({
              updates: items,
              sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname
            });

            if(items_remove == true){
              fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
                .then((response) => {
                  return response.text();
                })
                .then((state) => {
                  const parsedState = JSON.parse(state);
                  document.querySelector('cart-drawer').renderContents(parsedState)
                  if (document.querySelector('.drawer__inner').getAttribute('data-count') == '0'){
                    document.querySelector('cart-drawer').classList.add("is-empty"); 
                  }
                  if(document.querySelector('#gift_wrapping_input')?.checked == true && document.querySelector('.drawer__inner').getAttribute('data-count') == '1' ){
                    document.querySelector('#gift_wrapping_input').checked = false
                  }
                  // gift_events()
                }).catch((error) => {
                  console.error('Error:', error);
                })
            }
          }
        }
      }
    }
  }

function shipping_pro(){
  const cart_json = new XMLHttpRequest();
  const check_cart_json = new XMLHttpRequest();
  check_cart_json.open("GET", "/cart.js", true);
  check_cart_json.getResponseHeader("Content-type", "application/json");
  check_cart_json.send();
  check_cart_json.onload = function() {
    const shipping_id = parseInt(document.querySelector('body').getAttribute('data-shipping-pro'));
    const cart_data = JSON.parse(this.responseText);
    var has_shi_pro = false;
    cart_data.items.forEach(function(item){
      if(item.variant_id == shipping_id && has_shi_pro == false){
        has_shi_pro = true;
      }
    });
    
    if(shipping_id && document.querySelector('#gift_wrapping_input')){
      if(document.querySelector('#gift_wrapping_input').checked){
        if(has_shi_pro == false){
          var ship_upsell_item = [];
            ship_upsell_item.push({
              id: shipping_id, 
              quantity: 1
            });
          
          if(ship_upsell_item.length){
            var formData = {
             'items': ship_upsell_item,
             'sections': ['cart-drawer'],
             'attributes': {
                'gift_pro': 'yes'
              }
            }
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(response => {
              return response.json();
            })
            .then((json) => {
              const parser = new DOMParser();
              const doc1 = parser.parseFromString(json.sections['cart-drawer'], "text/html");
              document.querySelector('cart-drawer').innerHTML = doc1.querySelector('cart-drawer').innerHTML;
              document.querySelector('#gift_wrapping_input').checked = true;
              document.querySelector('.gift_wrapping .gift_wrapping_message').classList.add('gift_message_show');
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        }
      }else{
        if(has_shi_pro == true){
            let ship_items = {};
            ship_items[shipping_id]=0;
  
            const body = JSON.stringify({
              updates: ship_items,
              sections: document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id),
              sections_url: window.location.pathname,
              attributes: {
                'gift_pro': 'no'
              }
            });
  
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              const parsedState = JSON.parse(state);
              document.querySelector('cart-drawer').renderContents(parsedState)
              if (document.querySelector('.drawer__inner').getAttribute('data-count') == '0'){
                document.querySelector('cart-drawer').classList.add("is-empty"); 
              }
              // document.querySelector('#gift_wrapping_input').checked = false;
              document.querySelector('.gift_wrapping .gift_wrapping_message').classList.remove('gift_message_show');
            }).catch((error) => {
              console.error('Error:', error);
            })
        }
      }
    }
  } 

  
}

window.addEventListener('load', function() {
  if(document.querySelector('body.template-cart')){
    setCookie("opencart","yes", 30);
    window.location.href = "/";
  }else{
    checkCookie();
  }
});

function setCookie(cname,cvalue,exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user=getCookie("opencart");
  if (user != "") {
    document.querySelector('.header__icons .header__icon--cart').click();
    document.cookie = 'opencart' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

